import { PUBLIC_DOMAIN } from '@constants';

type TTSAvatarType = 'male' | 'female';

export type TTSConfigItem = {
  voiceId: string;
  name: string;
  avatar: TTSAvatarType;
  lang: string;
  sampleRate: number;
  isVip: boolean;
};

type TTSGroup = {
  id: number;
  name: string;
  items: TTSConfigItem[];
};

export const getDemoUrl = (id: TTSConfigItem['voiceId']) => {
  return `${PUBLIC_DOMAIN}/audios/ali-tts/${id}.mp3`;
};

export const ttsConfig: readonly TTSGroup[] = [
  {
    id: 1,
    name: '通用',
    items: [
      {
        avatar: 'female',
        name: '小云,标准女声',
        voiceId: 'xiaoyun',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾佳,标准女声',
        voiceId: 'aijia',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '思佳,标准女声',
        voiceId: 'sijia',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '宁儿,标准女声',
        voiceId: 'ninger',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '瑞琳,标准女声',
        voiceId: 'ruilin',
        lang: '支持中文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '若兮,温柔女声',
        voiceId: 'ruoxi',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '思琪,温柔女声',
        voiceId: 'siqi',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾琪,温柔女声',
        voiceId: 'aiqi',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '悦儿,儿童剧女声',
        voiceId: 'yuer',
        lang: '支持中文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '小刚,标准男声',
        voiceId: 'xiaogang',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '思诚,标准男声',
        voiceId: 'sicheng',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾诚,标准男声',
        voiceId: 'aicheng',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾达,标准男声',
        voiceId: 'aida',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 8,
    name: '超高清',
    items: [
      {
        avatar: 'female',
        name: '知佳,标准女声',
        voiceId: 'zhijia',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'female',
        name: '知琪,温柔女声',
        voiceId: 'zhiqi',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '知甜,甜美女声',
        voiceId: 'zhitian',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'female',
        name: '知倩,资讯女声',
        voiceId: 'zhiqian',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'female',
        name: '知茹,新闻女声',
        voiceId: 'zhiru',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'female',
        name: '知薇,萝莉女声',
        voiceId: 'zhiwei',
        lang: '支持中文',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'female',
        name: '知青,中国台湾话女生',
        voiceId: 'zhiqing',
        lang: '支持中文',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知祥,磁性男声',
        voiceId: 'zhixiang',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知飞,激昂解说',
        voiceId: 'zhifei',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知厨,舌尖男声',
        voiceId: 'zhichu',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知楠,广告男声',
        voiceId: 'zhinan',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知德,新闻男声',
        voiceId: 'zhide',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 48000,
      },
      {
        avatar: 'male',
        name: '知伦,悬疑解说',
        voiceId: 'zhilun',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 6,
    name: '文学',
    items: [
      {
        avatar: 'female',
        name: '艾媛,知心姐姐',
        voiceId: 'aiyuan',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾婷,电台女声',
        voiceId: 'aiting',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾凡,情感女声',
        voiceId: 'aifan',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾笑,资讯女声',
        voiceId: 'aixiao',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾倩,资讯女声',
        voiceId: 'aiqian',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾茹,新闻女声',
        voiceId: 'airu',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾祥,磁性男声',
        voiceId: 'aixiang',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾晔,青年男声',
        voiceId: 'aiye',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾树,资讯男声',
        voiceId: 'aishu',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾浩,资讯男声',
        voiceId: 'aihao',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾墨,情感男声',
        voiceId: 'aimo',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾德,新闻男声',
        voiceId: 'aide',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾楠,广告男声',
        voiceId: 'ainan',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾茗,诙谐男声',
        voiceId: 'aiming',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾厨,舌尖男声',
        voiceId: 'aichu',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾颖,软萌童声',
        voiceId: 'aiying',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 7,
    name: '直播',
    items: [
      {
        avatar: 'female',
        name: '柜姐,亲切女声',
        voiceId: 'guijie',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '小仙,亲切女声',
        voiceId: 'xiaoxian',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Stella,知性女声',
        voiceId: 'stella',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Rosa,自然女声',
        voiceId: 'rosa',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '猫小美,活力女声',
        voiceId: 'maoxiaomei',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '巧薇,卖场广播',
        voiceId: 'qiaowei',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '老妹,吆喝女声',
        voiceId: 'laomei',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Stanley,沉稳男声',
        voiceId: 'stanley',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Kenny,沉稳男声',
        voiceId: 'kenny',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾飞,激昂解说',
        voiceId: 'aifei',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '亚群,卖场广播',
        voiceId: 'yaqun',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾伦,悬疑解说',
        voiceId: 'ailun',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '老铁,东北老铁',
        voiceId: 'laotie',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 2,
    name: '客服',
    items: [
      {
        avatar: 'female',
        name: '艾美,甜美女声',
        voiceId: 'aimei',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '小美,甜美女声',
        voiceId: 'xiaomei',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '思悦,温柔女声',
        voiceId: 'siyue',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾悦,温柔女声',
        voiceId: 'aiyue',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾雅,严厉女声',
        voiceId: 'aiya',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾婧,严厉女声',
        voiceId: 'aijing',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '思婧,严厉女声',
        voiceId: 'sijing',
        lang: '支持中文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾夏,亲和女声',
        voiceId: 'aixia',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾雨,自然女声',
        voiceId: 'aiyu',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾娜,浙普女声',
        voiceId: 'aina',
        lang: '支持中文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '伊娜,浙普女声',
        voiceId: 'yina',
        lang: '支持中文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾硕,自然男声',
        voiceId: 'aishuo',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 5,
    name: '方言',
    items: [
      {
        avatar: 'female',
        name: '佳佳,粤语女声',
        voiceId: 'jiajia',
        lang: '支持粤/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '桃子,粤语女声',
        voiceId: 'taozi',
        lang: '支持粤/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '姗姗,粤语女声',
        voiceId: 'shanshan',
        lang: '支持粤/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '翠姐,东北话女声',
        voiceId: 'cuijie',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '青青,中国台湾话女声',
        voiceId: 'qingqing',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '艾侃,天津话男声',
        voiceId: 'aikan',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '大虎,东北话男声',
        voiceId: 'dahu',
        lang: '支持中/英混合',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '小泽,湖南重口音男声',
        voiceId: 'xiaoze',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 3,
    name: '童声',
    items: [
      {
        avatar: 'female',
        name: '艾彤,儿童音',
        voiceId: 'aitong',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '思彤,儿童音',
        voiceId: 'sitong',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '小北,萝莉女声',
        voiceId: 'xiaobei',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾薇,萝莉女声',
        voiceId: 'aiwei',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: '艾宝,萝莉女声',
        voiceId: 'aibao',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: '杰力豆,治愈童声',
        voiceId: 'jielidou',
        lang: '支持中文',
        isVip: false,
        sampleRate: 16000,
      },
    ],
  },
  {
    id: 4,
    name: '英文',
    items: [
      {
        avatar: 'female',
        name: 'Abby,美音女声',
        voiceId: 'abby',
        lang: '支持英文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'ava,美音女声',
        voiceId: 'ava',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Annie,美音女声',
        voiceId: 'annie',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Emily,英音女声',
        voiceId: 'emily',
        lang: '支持英文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Luna,英音女声',
        voiceId: 'luna',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Wendy,英音女声',
        voiceId: 'wendy',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Olivia,英音女声',
        voiceId: 'olivia',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'female',
        name: 'Lydia,英中双语女声',
        voiceId: 'lydia',
        lang: '支持中/英混合',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Andy,美音男声',
        voiceId: 'andy',
        lang: '支持英文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Harry,英音男声',
        voiceId: 'harry',
        lang: '支持英文',
        isVip: false,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Eric,英音男声',
        voiceId: 'eric',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'Luca,英音男声',
        voiceId: 'luca',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
      {
        avatar: 'male',
        name: 'William,英音男声',
        voiceId: 'william',
        lang: '支持英文',
        isVip: true,
        sampleRate: 16000,
      },
    ],
  },
];
